(function() {
    'use strict';

    var brandListCard = {
        templateUrl: 'app/components/brand-list-card/brand-list-card.html',
        controller: brandListCardController,
        bindings: {
            brand:'<',
            text: '@',
            icon: '@',
            onCardClick: '&',
            isActive: '<',
            isImmoContext: '<',
            selected: '<'
        },
        controllerAs: 'vm'
    };

    angular
        .module('showcaseApp')
        .component('brandListCard', brandListCard);

    /** @ngInject */
    function brandListCardController($rootScope, systemConstants) {
        var vm = this;

        vm.TRUNCATE_THRESHOLD = 30

        vm.handleClick = function() {
            vm.selected = !vm.selected;
            if (vm.onCardClick) {
                vm.onCardClick({
                    text: vm.text
                });
            }
        };

        vm.truncateText = function (text, size) {
            return truncateText(text, size);
        }

        var iconImageResolution = systemConstants.IMAGE_RESOLUTIONS.LIST_CARD;
        vm.iconCutted = getBrandIconImageWithResolution($rootScope.bucket, vm.brand, iconImageResolution);
    }
})();
